module.exports = __webpack_public_path__ + "static/media/Youniq_logo.d189ba14.png";